import {
    getActiveCheckautoRequest,
    getActivePartsRequest,
    getActivePlacementRequest,
    getActiveRentRequest,
    getActiveSellRequest,
    getActiveServicesRequest,
} from '../../../services/network/common/active';

class ActiveSectionsService {
    async getActiveSellList() {
        return await getActiveSellRequest();
    }

    async getActiveCheckautoList() {
        return await getActiveCheckautoRequest();
    }

    async getActiveRentList() {
        return await getActiveRentRequest();
    }

    async getActivePartsList() {
        return await getActivePartsRequest();
    }

    async getActivePlacementList() {
        return await getActivePlacementRequest();
    }

    async getActiveServicesList() {
        return await getActiveServicesRequest();
    }
}

export const ActiveService = new ActiveSectionsService();
